// Keep camelCase and PascalCase API responses compatible without rewriting payloads.
export const readValue = (value, camel, pascal) => value?.[camel] ?? value?.[pascal];
export const asArray = (value) => Array.isArray(value) ? value : [];

export const buildStorefrontUrl = (baseUrl, path) =>
  `${baseUrl.trim().replace(/\/+$/, "")}/storefront-search/${path}`;

export const formatPrice = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? `$${number.toFixed(2)}` : null;
};

export const validationMessage = (data) => {
  const errors = data?.errors;
  return errors && typeof errors === "object"
    ? Object.values(errors).flat().filter(Boolean).join(" ")
    : "";
};

export const configurationErrorMessage = (error, fallback, includeMessage = false) => {
  const data = error?.response?.data;
  return validationMessage(data) || data?.title || (includeMessage && data?.message)
    || (typeof data === "string" ? data : null) || error?.message || fallback;
};
